import { Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormBuilder, Validators } from '@angular/forms';
import {
  RdsDialogModule,
  RdsButtonModule,
  RdsFormFieldModule,
  RdsDialogRef,
  RDS_DIALOG_DATA,
} from '@rds/angular-components';
import { BUTTON_TEXTS } from '../../../../constants/buttons.constants';
import { ERRORS_TEXTS } from '../../../../constants/errors.contstants';
import { KnowledgeTechnicalResource } from '../../../../models/knowledge';
import { urlValidator } from '../../../../validators';
import { POPUPS } from '../../../../constants/popups.constants';

@Component({
  selector: 'inexp-focus-technical-resource-dialog',
  imports: [
    ReactiveFormsModule,
    RdsDialogModule,
    RdsButtonModule,
    RdsFormFieldModule,
  ],
  templateUrl: './focus-technical-resource-dialog.component.html',
  styleUrl: './focus-technical-resource-dialog.component.scss',
})
export class FocusTechnicalResourceDialogComponent {
  private readonly _fb = inject(FormBuilder);
  private readonly _dialogRef =
    inject<RdsDialogRef<FocusTechnicalResourceDialogComponent>>(RdsDialogRef);
  protected readonly data = inject(RDS_DIALOG_DATA) as {
    technicalResources?: KnowledgeTechnicalResource;
  };
  readonly ERRORS = ERRORS_TEXTS;
  readonly BUTTONS = BUTTON_TEXTS;
  readonly POPUPS = POPUPS;

  form = this._fb.group({
    title: [this.data.technicalResources?.title ?? '', Validators.required],
    url: [
      this.data.technicalResources?.url ?? '',
      [Validators.required, urlValidator()],
    ],
  });

  submit() {
    if (this.form.valid) {
      this._dialogRef.close(this.form.value);
    } else {
      this.form.markAllAsTouched();
    }
  }
}
